module.exports = __webpack_public_path__ + "static/media/mv.27dd24a9.svg";